import React from "react";
import { 
    Flex, 
    Stat,
    StatLabel,
    StatNumber,
    StatHelpText,
    Box,
} from "@chakra-ui/react";
import { stats } from "../../utilities/dummy";
import { computeStatBgColour } from "../../utilities/ui";

export default function ProductsStats() {

    return (
        <Box paddingBottom='4' paddingTop='6' width='100%'>
            <Flex paddingX={'8'} wrap='wrap' alignItems={'center'}>
                {stats.map((stat) => (
                    <Box 
                        key={stat.id}
                        borderRadius='lg' 
                        borderColor='gray.200' 
                        padding='3' 
                        paddingX={'4'}
                        background={computeStatBgColour(stat.type)} 
                        minWidth={'250px'}
                        marginBottom='8'
                        marginRight={'8'}
                        boxShadow='lg'
                    >
                        <Stat>
                            <StatLabel color={'#1a202c'}>{stat.label}</StatLabel>
                            <StatNumber fontSize={'md'}>{stat.amount}</StatNumber>
                            <Flex alignItems={'center'} marginTop='2'>
                                <StatHelpText>{stat.deals} deals | </StatHelpText>
                                <StatHelpText marginLeft={'1'}>{stat.date}</StatHelpText>
                            </Flex>
                        </Stat>
                    </Box>    
                ))}
            </Flex>
        </Box>
    )
}